export default __webpack_public_path__ + "static/media/11.95ba86de.png";